module.exports = __webpack_public_path__ + "static/og-25c7cd559f0b7f9242911b59c96fc1d2.png";